import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <div className="spinner-icon" />
    </div>
  );
};

export default LoadingSpinner;
